import React from "react";
import { Row, Col, Card, Button } from "antd";
import { EditFilled } from "@ant-design/icons";



const View = ({ onAdd }) => {


    return (
        <>
            <Card style={{ border: "none", backgroundColor: '#00000008', color: '#000' }} bodyStyle={{ padding: '15px' }}>
                <Row gutter={24} align='middle'>
                    <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
                    <Col xl={16} lg={16} md={124} sm={0} xs={0} className="text-center">
                        <h3 className="m-0 p-0" style={{ color: "#000" }}>Rrjetet Sociale</h3>
                    </Col>
                    <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-right" >
                        <Button type="primary" onClick={onAdd} icon={<EditFilled />}>Modifiko</Button>
                    </Col>
                </Row>
            </Card>
        </>
    );
};

export default View;